import { render, staticRenderFns } from "./cursoListagem.vue?vue&type=template&id=0f9c4559&scoped=true&"
import script from "./cursoListagem.vue?vue&type=script&lang=js&"
export * from "./cursoListagem.vue?vue&type=script&lang=js&"
import style0 from "./cursoListagem.vue?vue&type=style&index=0&id=0f9c4559&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9c4559",
  null
  
)

export default component.exports